<template>
  <div class="editorial">
    <div class="editorial_nav">
    <!-- <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2">
          首页 <span class="span1">></span>{{titlename}}<span class="span1">></span> <span class="span2">{{list3.title}}</span>
        </div>
      </div> -->

       <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2" style="cursor: pointer;" @click="tiao">
          首页 <span class="span1">></span> <span class="span2">联系我们</span>
        </div>
      </div>

      <div class="express_rtitle">
          <div class="waike">联系我们</div>
          <div class="waixian"></div>
      </div>

        <div class="meContent">
            <div class="detail">
          <!-- <div class="iconfont icon-didian" style="margin-right: 5px;"></div> -->
              <div class="detailMain">
                  <div class="topa">
                    <div class="iconfont icon-dizhi " style="margin-right: 5px;marginTop:2px;float:left;color:#8799B2;fontSize:26px"></div>   <div>地址：<span>北京市西城区北礼士路167号 阜外医院院内</span></div>
                  </div>

                  <div  class="topa">
                      <div class="iconfont icon-sangeren " style="margin-right: 5px;marginTop:5px;float:left;color:#8799B2;fontSize:26px"></div> <div>邮政编码：<span>100037</span></div>
                      <div class="leftaa" >通联部：<span>010-68331974</span></div>
                      <div class="leftaa" >编辑部：<span>010-68332599 010-68331758</span></div>
                  </div>
                  
                  <div  class="topa">
                       <div class="iconfont icon-youjian " style="margin-right: 5px;marginTop:2px;float:left;color:#8799B2;fontSize:26px"></div>
                      <div class="leftaa" >通联部邮箱：<span>zgxhzz@vip.163.com</span></div>
                      <div class="leftaa" >编辑部：<span>010-68332599 010-68331758</span></div>
                  </div>

                  <div  class="topa">
                        <div class="iconfont icon-f-earth-diqiu " style="margin-right: 5px;marginTop:px;float:left;color:#8799B2;fontSize:26px"></div>  <div>网站（投稿平台）<span>www.chinacirculation.org</span></div>
                  </div>
              </div>
          </div>
        </div>
      <!-- <div class="editorial_left">
        <div class="editorial_txt1">{{list3.title}}</div>
        <div class="tuxq" v-html="list3.content"></div>
      </div> -->
      <!-- <div class="editorial_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div> -->
    </div>
  </div>
</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components:{
    advertisement
  },
  data () {
    return {
      titlename: '',
      currentPage3: 1,//当前页数
      total: 0,//总条数
      list3: [],//详情数据
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
        video2: true,
      },//控制广告栏的显示隐藏
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      list: [
        {
          id: 1,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 2,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 3,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 4,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 5,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 6,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 7,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 8,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 9,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        }
      ],//专家列表
    }
  },

  methods:{
      //获取内容详情
      GetContentInfo(channelId){
        var that = this;
        that.$httphelper.GetContentInfo({
          "journalId": that.$_JournalId,
          "year":  0,
          "issue": 0,
          "channelId": channelId,
          "contentId": 155170,
          "dataSourceType": 1,
          "dataShowType": 2
        }).then(res => {
          if(res.code==200){
            that.list3 = res.data.siteContentInfoResult || '';
            that.$loading.hideLoading();
          }else{
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
       tiao(){
      this.$router.push({path:'/home'});
      },
      index(){
        sessionStorage.setItem('routerIndex',12);
        this.total = this.list.length;
        this.GetContentInfo(2807);
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage3 = val;
        console.log(`当前页: ${val}`);
      },
      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list2.length;i++){
            if(id==this.list2[i].id){
              this.list2[i].zt = true;
              this.list2.push('1');
              this.list2.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list2.length;i++){
            this.list2[i].zt = false;
            this.list2.push('1');
            this.list2.pop('1');
          }
        }
      },
  },
  created(){
    this.$loading.showLoading();
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  .editorial_nav{
    width: 60%;
    margin: 0 auto;
    overflow: hidden;
    padding-bottom: 42px;
    padding-top: 50px;
    .meContent{
      height: 1236px;
      width: 100%;
      // border: 1px solid #ccc;
      .detail{
        // height: 373px;
        width: 100%;
        padding-bottom: 20px;
        background-color: #F7F7F7;
        .detailMain{
          width: 70%;
          height: 100%;
          margin: 0 auto;
          .topa{
            margin-left: 30px;
            margin-top: 30px;
            padding-top: 20px;
            .leftaa{
              margin-left: 31px;
            }
            div{
              font-size: 20px;
              margin-top: 5px;
              span{
                font-size: 14px;
              }
            }
            
          }
        }
      }
    }
    .editorial_txt{
      width: 100%;
      margin-top: 24px;
      margin-bottom: 30px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
     .express_rtitle {
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #DBDBDB;
        padding-bottom: 11px;
        position: relative;
        .waike {
          width: 50%;
          float: left;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2A2D3E;
          line-height: 23px;
          margin-bottom: 20px;
        }
        .waixian {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100px;
          height: 3px;
          background: #E6454A;
        }
      }
    .editorial_left{
      width: 100%;
      margin-right: 3%;
      background-color: #DBDFE8;
      float: left;
      .tuxq{
        width: 100%;
        height: auto;
        max-height: 1400px;
        overflow-y: auto;
        font-size: 16px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #000000;
        line-height: 30px;
        padding-bottom: 50px;
        border-bottom: 1px solid #F6F6F6;
        /deep/ p{
          margin: 0;
        }
        /deep/ img{
          width: 100%!important;
        }
      }
      .editorial_txt1{
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #000000;
        margin-bottom: 21px;
      }
      .editorial_txt2{
        width: 100%;
        line-height: 46px;
        background: #F5F5F5;
        margin-bottom: 43px;
        span{
          margin-right: 15px;
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
          line-height: 46px;
        }
        span:last-child{
          margin-right: 0;
        }
      }
      .editorial_txt3{
        width: 100%;
        font-size: 16px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #000000;
        line-height: 30px;
        padding-bottom: 50px;
        border-bottom: 1px solid #F6F6F6;
      }
      .editorial_txt4{
        width: 100%;
        overflow: hidden;
        padding-top: 46px;
        .editorial_txt4l{
          width: 18%;
          margin-right: 3%;
          float: left;
          cursor: pointer;
          img{
            width: 100%;
            height: 228px;
          }
          img:hover{
            transform: scale(1.03);
          }
        }
        .editorial_txt4r{
          width: 79%;
          float: left;
          .editorial_txt4rtxt1{
            width: 100%;
            font-size: 20px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            line-height: 30px;
            margin-bottom: 25px;
          }
          .editorial_txt4rtxt2{
            width: 100%;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            line-height: 30px;
          }
        }
      }
      .shang{
        width: 100%;
        background-color: #F7F7F7;
        margin-top: 49px;
        .shang_nav{
          width: 80%;
          overflow: hidden;
          margin: 0 auto;
          .shangl,.shangr{
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            color: #000000;
            line-height: 48px;
            cursor: pointer;
            white-space: nowrap;//强制字体不换行
            text-overflow: ellipsis;//超出字体隐藏
            overflow:hidden;
            span:hover{
              color: var(--biao);
              text-decoration: underline;
            }
          }
        }
      }
      .browse_recommend{
        width: 100%;
        margin-top: 49px;
        overflow: hidden;
        .one{
          width: 43%;
          float: left;
          overflow: hidden;
          margin-top: 14px;
          .one_xu{
            width: 85%;
            height: 1px;
            border-bottom: 1px dashed #E4E4E4;
            display: block;
            float: left;
          }
          .one_xian{
            width: 15%;
            height: 1px;
            background-color: var(--biao);
            display: block;
            float: left;
          }
        }
        .browse_recommendtxt{
          width: 14%;
          float: left;
          text-align: center;
          font-size: 20px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
          line-height: 28px;
        }
        .two{
          width: 43%;
          float: left;
          overflow: hidden;
          margin-top: 14px;
          .two_xu{
            width: 85%;
            height: 1px;
            border-bottom: 1px dashed #E4E4E4;
            display: block;
            float: left;
          }
          .two_xian{
            width: 15%;
            height: 1px;
            background-color: var(--biao);
            display: block;
            float: left;
          }
        }
      }
      .recommendtxt_list{
        width: 99.8%;
        border: 1px solid #EBEBEB;
        padding: 30px 0 36px 0;
        margin-top: 43px;
        .express_nav2r {
          width: 95%;
          overflow: hidden;
          margin: 0 auto;
          .express_list2 {
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            margin-bottom: 45px;
            line-height: 20px;
            .express_dian {
              width: 10px;
              height: 10px;
              background: #DBDBDB;
              border-radius: 50%;
              margin-right: 25px;
              float: left;
              margin-top: 5px;
            }

            .express_wen {
              width: 91%;
              float: left;

              .wen1 {
                width: 100%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;


                .span3 {
                  width: 100%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  float: left;
                }
              }

              .wen2 {
                width: 100%;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;
                margin-bottom: 10px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }

            .zhai {
              width: 90%;
              padding-left: 31px;
              overflow: hidden;
              float: left;

              .wen3 {
                width: 50%;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;
                float: left;
              }

              .zhai_left,
              .zhai_right {
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                float: right;
              }

              .zhai_right {
                margin-left: 30px;
              }

              .zhai_left:hover {
                text-decoration: underline;
                color: var(--biao);
              }

              .zhai_right:hover {
                text-decoration: underline;
                color: var(--biao);
              }
            }
          }
          .express_list2:last-child{
            margin-bottom: 0;
          }
        }
      }
    }
    .editorial_right{
      width: 25%;
      float: right;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  color: var(--xt) !important;
}

.add3 {
  background-color: #FAFAFA !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/contact.vue